module.exports = __webpack_public_path__ + "static/media/1POLICY47.a925c54e.jpg";